import { Button } from 'component/Button'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import { InferenceStore } from 'store/inference/InferenceStore'
import { opt } from 'store/opt'

type Props = {
  inference: InferenceStore
}

export const BuyButtons = observer(({ inference }: Props) => {
  const { links_name, items } = inference

  const onLink = useLatestCallback(() => {
    if (items.length > 1) controller.openBuyBanner(inference)
    else controller.openBuy(inference)
  })

  return (
    <>
      <Button primary large wide action={onLink}>
        {links_name || opt.buy_title}
      </Button>
    </>
  )
})
